import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import { TInvestFundAssetClassTag } from '../../../../../types/fund/TInvestFundAssetClassTag';

type CFiltersAssetClassSelectProps = {
	optionsAssetClasses: { id: TInvestFundAssetClassTag; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersAssetClassSelect = (props: CFiltersAssetClassSelectProps) => {
	const { optionsAssetClasses, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsAssetClasses ? (
				<CAppFilterSelect
					className="filter-asset-classes"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={
						filters?.assetClasses
							? optionsAssetClasses.filter((x) => filters.assetClasses?.includes(x.id))
							: null
					}
					onChange={(val: { id: TInvestFundAssetClassTag; name: string }[]) =>
						onChange({
							...filters,
							assetClasses: val ? val.map((x) => x.id) : null,
						})
					}
					label={label}
					size="small"
					options={optionsAssetClasses}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersAssetClassSelect;
